import SavedTranscriptTypes from '../action-types/saved-transcript';
import { filterAccessibleTranscripts, filterDeletedManyTranscripts, filterDeletedTranscript, retrieveLastReadTranscript, updateTranscripts, } from '../reducer-utils/saved-transcript';
const INITIAL_STATE = {
    loading: false,
    deleteLoading: false,
    updateTitleLoading: false,
    hasMoreTranscripts: true,
    lastReadTimestamp: null,
    transcripts: [],
    selectedId: '',
    error: '',
};
const savedTranscriptReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SavedTranscriptTypes.FETCH_TRANSCRIPTS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true });
        case SavedTranscriptTypes.FETCH_TRANSCRIPTS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, lastReadTimestamp: retrieveLastReadTranscript(action.payload).startTimestampMs, transcripts: filterAccessibleTranscripts(state.transcripts, action.payload) });
        case SavedTranscriptTypes.FETCH_TRANSCRIPTS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case SavedTranscriptTypes.SET_HAS_MORE_TRANSCRIPTS:
            return Object.assign(Object.assign({}, state), { loading: false, hasMoreTranscripts: action.payload });
        case SavedTranscriptTypes.DELETE_TRANSCRIPT_REQUEST:
            return Object.assign(Object.assign({}, state), { deleteLoading: true });
        case SavedTranscriptTypes.DELETE_TRANSCRIPT_SUCCESS:
            return Object.assign(Object.assign({}, state), { deleteLoading: false, transcripts: filterDeletedTranscript(state.transcripts, action.payload) });
        case SavedTranscriptTypes.DELETE_MANY_TRANSCRIPTS_SUCCESS:
            return Object.assign(Object.assign({}, state), { deleteLoading: false, transcripts: filterDeletedManyTranscripts(state.transcripts, action.payload) });
        case SavedTranscriptTypes.DELETE_TRANSCRIPT_FAILURE:
            return Object.assign(Object.assign({}, state), { deleteLoading: false, error: action.payload });
        case SavedTranscriptTypes.SET_SELECTED_TRANSCRIPT_ID:
            return Object.assign(Object.assign({}, state), { selectedId: action.payload });
        case SavedTranscriptTypes.RESET_TRANSCRIPTS:
            return Object.assign(Object.assign({}, state), { hasMoreTranscripts: true, lastReadTimestamp: null, loading: false, transcripts: [] });
        case SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_REQUEST:
            return Object.assign(Object.assign({}, state), { updateTitleLoading: true });
        case SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateTitleLoading: false, transcripts: updateTranscripts(state.transcripts, action.payload) });
        case SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_FAILURE:
            return Object.assign(Object.assign({}, state), { updateTitleLoading: false, error: action.payload });
        case SavedTranscriptTypes.ADD_NEW_TRANSCRIPT:
            return Object.assign(Object.assign({}, state), { lastReadTimestamp: state.transcripts.length
                    ? retrieveLastReadTranscript(state.transcripts).startTimestampMs
                    : action.payload.startTimestampMs, transcripts: filterAccessibleTranscripts([action.payload], state.transcripts) });
        default:
            return state;
    }
};
export default savedTranscriptReducer;
